import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Input from 'react-phone-number-input/input';

import './index.css';
import gameimg from '../../assets/images/gameimg.png';
import biglogo from '../../assets/images/biglogo.png';
import message from '../../assets/images/message.svg';
import phone from '../../assets/images/phone.svg'
import lock from '../../assets/images/lock.svg';
import facebook from '../../assets/images/facebook.svg';
import google from '../../assets/images/google.svg';
import apple from '../../assets/images/apple.svg';
import hide from '../../assets/images/hide.svg';

import { loginAct, verifyCodeAct } from '../../store/actions/authActions';
import { auth, RecaptchaVerifier, signInWithPhoneNumber } from '../../firebase';

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token, loading, error } = useSelector((state) => state.auth);

    const [formData, setFormData] = useState({})

    const [phoneNumber, setPhoneNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [confirmationResult, setConfirmationResult] = useState('');

    // Redirect to the index route after successful login
    useEffect(() => {
        if (token) {
            navigate('/'); // Redirect to the index route or desired page
        }
    }, [token, navigate]);

    const handleChange = (e, prop) => {
        let inputData = { ...formData }
        inputData[prop] = e && e.target ? e.target.value : e;
        setFormData(inputData);
    }

    const setupRecaptcha = () => {
        if (!window.recaptchaVerifier) {
            window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha', {
                'size': 'invisible',
                'callback': (response) => {
                    // reCAPTCHA solved, allow signInWithPhoneNumber.
                    console.log("reCAPTCHA solved", response);
                },
                'expired-callback': () => {
                    console.log("reCAPTCHA expired");
                }
            });
        }
    }

    const sendOtp = () => {
        setupRecaptcha();
        let appVerifier = window.recaptchaVerifier;
        console.log(formData['email'], 'phoneNumber')
        console.log(confirmationResult, 'confirmationResult')
        signInWithPhoneNumber(auth, formData['email'], appVerifier)
            .then((confirmationResult) => {
                // SMS sent. Prompt user to type the code from the message, then sign the
                // user in with confirmationResult.confirm(code).
                console.log(confirmationResult, 'confirmationResult')
                setConfirmationResult(confirmationResult)
                window.confirmationResult = confirmationResult;
            }).catch((error) => {
                // Error; SMS not sent
                console.log(error);
            });
    };

    const verifyOtp = () => {
        confirmationResult
            .confirm(formData['otp'])
            .then((result) => {
                const user = result.user;
                console.log(user, 'user verify')
                dispatch(verifyCodeAct(formData));
                navigate('/login')
                alert('Phone verified! User:', formData['email']);
            })
            .catch((error) => {
                console.error('Error verifying OTP:', error);
            });
    };

    console.log(confirmationResult, 'confirmationResult')

    return (
        <>
            <div className='screen-1-section'>
                <div className='screen-1-content'>
                    <div className='screen-gameimgpart'>
                        <div className='screen-gameimage'>
                            <img src={gameimg} alt="gameimg" className='img-fluid' />
                        </div>
                        <div className='screen-logo-part'>
                            <div className='screen-1-logo-image'>
                                <Link to="/landing">
                                    <img src={biglogo} alt="logo" className='img-fluid' />
                                </Link>
                            </div>
                            <div className='screen-1-main-title'>
                                <h3>BallHog</h3>
                            </div>
                        </div>
                    </div>
                    <div className='screen-form'>
                        <Form>
                            <Form.Group controlId="formGroupEmail" className='form-group' style={{ margin: '30px 0' }}>
                                <Input 
                                    country="US"
                                    international
                                    withCountryCallingCode
                                    value={formData['email']} 
                                    className='form-control' 
                                    onChange={(e) => handleChange(e, 'email')} 
                                    placeholder="Phone Number" />
                                <img src={phone} alt="phone" className='img-fluid' />
                            </Form.Group>
                            {!confirmationResult && <Button className='sign-in-btn' onClick={sendOtp}>Submit</Button>}
                        </Form>
                        {confirmationResult && (
                            <Form>
                                <Form.Group controlId="formGroupEmail" className='form-group' style={{ margin: '30px 0' }}>
                                    <Form.Control type='text' value={formData['otp']} className='form-control' onChange={(e) => handleChange(e, 'otp')} placeholder="Code" />
                                    <img src={phone} alt="phone" className='img-fluid' />
                                </Form.Group>
                                <Button className='sign-in-btn' onClick={verifyOtp}>LOGIN</Button>
                            </Form>
                        )}
                        <span className='devider'>or continue with</span>
                        <div className='sign-up-block'>
                            <p>Don't have an account? <Link to="/register">Sign up</Link></p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="recaptcha"></div>
        </>
    )
}

export default ForgotPassword
